import mwcMarketsCore from 'mwc-markets-core';
import Forex from './src/forex.vue';

const { createCustomElement } = mwcMarketsCore;
createCustomElement(Forex);

export default Forex;
